import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const PaymentGatewayIntegrationInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Payment Gateway Integration in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Streamline Your Payments</Subheading>}
        heading={
          <Heading>
            Payment Gateway <span tw="text-primary-500">Integration</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset provides expert payment gateway integration in **Al
            Barsha**, ensuring secure, seamless, and versatile payment solutions
            for your e-commerce store to boost customer trust and sales.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce checkout
          "https://images.unsplash.com/photo-1580048915913-4f8f5cb481c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment security
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Credit card payment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Integrate Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Seamless Payment Solutions"
        description="Our integrations simplify transactions and build trust."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Multiple Options",
            description: "Support for cards, wallets, and more.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "PCI Compliance",
            description: "Secure payment processing.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Go live in days, not weeks.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Integrations",
            description: "Tailored to your platform.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Ready",
            description: "Smooth payments on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local payment specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Integrate</Subheading>}
        heading="Our Payment Gateway Integration Process"
        description={
          <Description>
            We ensure flawless payment systems:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Identify your payment needs.</li>
              <li>Selection: Choose gateways like Stripe, PayPal, or Telr.</li>
              <li>Integration: Seamlessly embed into your store.</li>
              <li>Testing: Verify security and functionality.</li>
              <li>Launch: Enable smooth transactions.</li>
              <li>Support: Monitor and troubleshoot issues.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742111-a301076d9d18?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment system integration
          "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure transaction
          "https://images.unsplash.com/photo-1571867424488-4565932edb41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment gateway testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Payment Integration Success in Al Barsha"
        description="Our solutions drive seamless transactions."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Transaction Growth",
            description: "40% more completed payments.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Zero Downtime",
            description: "Reliable payment systems.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "94% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Transact?</Subheading>}
        heading="Payment Gateway Integration in Al Barsha"
        description={
          <Description>
            MilaajBrandset offers expert payment gateway integration in Al
            Barsha, delivering secure and seamless solutions for your online
            store. Contact us to get started today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1593510987185-1ec2256148a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile payment
          "https://images.unsplash.com/photo-1534224039826-c7a0fb1c5c1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai skyline for local context
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
